import styled from "styled-components";

export const StyledTableHead = styled.thead`
	border: none;
	border-radius: inherit;
`;
